export enum enumScheduleDailyFrequencyTime {
  Minutes = 1,
  Hourly
}

export namespace enumScheduleDailyFrequencyTime {
  export function values() {
    return Object.keys(enumScheduleDailyFrequencyTime).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
